var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-text-gray-500 tw-text-xs tw-font-normal"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"tw-text-gray-800 tw-text-sm"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }